export function getDialogPodNumber(url: string = '') {
    const pattern = /i20-alan-dialog-\d+/g;
    const matches = url.match(pattern);
    return matches?.length > 0 ? matches[0] : '-';
}